"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _airbnbPropTypes = require("airbnb-prop-types");
var _propTypes2 = require("@agillic/prop-types");
var _formattedNumber = require("./formattedNumber.helper");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var FormattedNumber = function FormattedNumber(_ref) {
  var children = _ref.children,
    hasPercent = _ref.hasPercent,
    precision = _ref.precision,
    currency = _ref.currency,
    fractionDigits = _ref.fractionDigits,
    integerDigits = _ref.integerDigits,
    groupSeparator = _ref.groupSeparator,
    fractionSeparator = _ref.fractionSeparator,
    currencyPosition = _ref.currencyPosition,
    uniqueID = _ref.uniqueID;
  var numberToFormat = (0, _formattedNumber.stringToNumber)(children);
  var positiveRoundedNumber = (0, _formattedNumber.getPositiveRoundedNumber)({
    hasPercent: hasPercent,
    numberToFormat: numberToFormat,
    precision: precision
  });
  var _numberToIntegerAndFr = (0, _formattedNumber.numberToIntegerAndFraction)({
      number: positiveRoundedNumber,
      fractionDigits: fractionDigits,
      integerDigits: integerDigits,
      groupSeparator: groupSeparator
    }),
    integer = _numberToIntegerAndFr.integer,
    fraction = _numberToIntegerAndFr.fraction;
  var joinedGroupedParts = "".concat(integer).concat(fractionSeparator).concat(fraction);
  var signaledGroupParts = positiveRoundedNumber < 0 ? "-".concat(joinedGroupedParts) : joinedGroupedParts;
  return _react.default.createElement("span", {
    "data-testid": uniqueID
  }, currency ? (0, _formattedNumber.withCurrencySign)({
    currencyPosition: currencyPosition,
    currency: currency,
    number: signaledGroupParts
  }) : (0, _formattedNumber.withoutCurrencySign)({
    hasPercent: hasPercent,
    number: signaledGroupParts
  }));
};
FormattedNumber.propTypes = {
  currency: _propTypes.string,
  hasPercent: (0, _airbnbPropTypes.and)([_propTypes.bool, (0, _propTypes2.forbiddenBy)('currency')]),
  children: _propTypes.string.isRequired,
  fractionDigits: _propTypes.number.isRequired,
  integerDigits: _propTypes.number.isRequired,
  groupSeparator: _propTypes.string.isRequired,
  precision: _propTypes.number.isRequired,
  uniqueID: _propTypes.string,
  fractionSeparator: (0, _airbnbPropTypes.and)([(0, _propTypes2.differentFrom)('groupSeparator'), (0, _propTypes2.minimumLength)(1), _propTypes2.notOnlyWhiteSpace, _propTypes.string.isRequired]),
  currencyPosition: (0, _airbnbPropTypes.and)([(0, _propTypes.oneOf)(['start', 'end']), (0, _propTypes2.requiredBy)('currency'), (0, _propTypes2.forbiddenBy)('percent')])
};
FormattedNumber.defaultProps = {
  precision: -2,
  fractionDigits: 3,
  integerDigits: 4,
  groupSeparator: ' ',
  fractionSeparator: '.',
  currencyPosition: undefined
};
var _default = FormattedNumber;
exports.default = _default;